<template>
    <div class="your-dates__date your-dates__date--tong-shu">
        <label>
            <div class="form__checkbox">
                <input v-model="selected_date" class="input--checkbox" type="checkbox"
                       name="checkbox_example">
                <span class="checkbox-text"></span>
            </div>
            <div class="your-dates__date-title">
                {{day.date|moment('dddd')}}
                <strong>{{day.date|moment('D. MMM YYYY')}}</strong>
            </div>
            <div class="your-dates__category">
                <span class="main-category-icon" :class="categoryIcon"></span> {{categoryName}}
            </div>
            <div class="tune-your-day__category">
                <div v-if="day.influence=='authority'" class="tune-your-day__category-title" v-translate>Authority / Career</div>
                <div v-if="day.influence=='support'" class="tune-your-day__category-title" v-translate>Support / Health</div>
                <div v-if="day.influence=='relations'" class="tune-your-day__category-title" v-translate>Relations</div>
                <div v-if="day.influence=='wealth'" class="tune-your-day__category-title" v-translate>Wealth</div>
                <div v-if="day.influence=='output'" class="tune-your-day__category-title" v-translate>Talent / Output</div>
                <div class="tune-your-day__progress-bar progress-bar">
                    <div class="progress-bar__bar" :style="{width: day.strengths[day.influence]+'%'}"></div>
                </div>
            </div>
            <tune-your-day-icon :value="day.react"></tune-your-day-icon>
        </label>
    </div>
</template>
<script>
    import TuneYourDayIcon from "../../components/dashboard/TuneYourDayIcon";
    import {mapState} from "vuex";

    export default {
        name: 'tong-shu-date',
        components: {TuneYourDayIcon},
        props: {
            day: {},
            value: {},
            activity: {}
        },
        computed: {
            ...mapState(['categories']),
            selected_date: {
                get: function () {
                    return this.value == this.day.date
                },

                set: function (newValue) {
                    if (newValue) {
                        this.$emit('input', this.day.date)
                        this.$set(this.activity,'strength',null)
                    } else {
                        this.$emit('input', null)
                        this.$set(this.activity,'strength',null)
                    }

                }
            },
            categoryIcon: function () {
                for (let i = 0; i < this.categories.length; i++) {
                    if (this.categories[i].id == this.activity.category) {
                        return 'icon-' + this.categories[i].icon
                    }
                }
                return ''

            },
            categoryName: function () {
                for (let i = 0; i < this.categories.length; i++) {
                    if (this.categories[i].id == this.activity.category) {
                        return this.categories[i].name
                    }
                }
                return ''

            }
        }
    }
</script>